import React from 'react';

function NuevoClienteModal({ visible, nuevoCliente, setNuevoCliente, onCrear, onCancelar }) {
  if (!visible) return null;

  const handleCrear = () => {
    if (!nuevoCliente.nombre.trim()) {
      alert('El nombre del cliente es obligatorio.');
      return;
    }
    onCrear(nuevoCliente);
  };

  const handleCancelar = () => {
    setNuevoCliente({
      nombre: '',
      telefono: '',
      observaciones: '',
      codigo_cliente: '',
      email: '',
      direccion: '',
      es_cliente_mantenimiento: true,
    });
    onCancelar();
  };

  return (
    <div className="full-modal">
      <div className="modal-content">
        <h3>➕ <strong>Nuevo Cliente</strong></h3>

        <input
          className="input"
          placeholder="Código de Cliente"
          value={nuevoCliente.codigo_cliente}
          onChange={e => setNuevoCliente({ ...nuevoCliente, codigo_cliente: e.target.value })}
        />

        <input
          className="input"
          placeholder="Nombre"
          value={nuevoCliente.nombre}
          onChange={e => setNuevoCliente({ ...nuevoCliente, nombre: e.target.value })}
        />

        <input
          className="input"
          placeholder="Teléfono"
          value={nuevoCliente.telefono}
          onChange={e => setNuevoCliente({ ...nuevoCliente, telefono: e.target.value })}
        />

        <input
          className="input"
          placeholder="Email"
          value={nuevoCliente.email}
          onChange={e => setNuevoCliente({ ...nuevoCliente, email: e.target.value })}
        />

        <input
          className="input"
          placeholder="Dirección"
          value={nuevoCliente.direccion || ''}
          onChange={e => setNuevoCliente({ ...nuevoCliente, direccion: e.target.value })}
        />

        <textarea
          className="textarea"
          placeholder="Observaciones"
          value={nuevoCliente.observaciones}
          onChange={e => setNuevoCliente({ ...nuevoCliente, observaciones: e.target.value })}
        />

        <label className="checkbox-field">
          <input
            type="checkbox"
            checked={nuevoCliente.es_cliente_mantenimiento !== false}
            onChange={e => setNuevoCliente({ ...nuevoCliente, es_cliente_mantenimiento: e.target.checked })}
          />
          Cliente de mantenimiento
        </label>

        <div className="button-group" style={{ marginTop: 15 }}>
          <button type="button" className="button primary" onClick={handleCrear}>✅ Crear</button>
          <button type="button" className="button danger" onClick={handleCancelar}>❌ Cancelar</button>
        </div>
      </div>
    </div>
  );
}

export default NuevoClienteModal;
